import * as actionTypes from "../actionTypes";

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 12/3/20
 * Time: 11:12 AM
 */

export const socketSelectBranchVisitorHandler = (data) => {
  return {
    type: actionTypes.SOCKET_SELECT_BRANCH_VISITOR,
    value: data
  }
};
export const socketBranchIdStoreHandler = (data) => {
  return {
    type: actionTypes.SOCKET_BRANCH_ID,
    value: data
  }
};
export const socketRemoveBranchVisitorHandler = (data) => {
  return {
    type: actionTypes.SOCKET_DELETE_BRANCH_VISITOR,
    value: data
  }
};

export const socketFetchAllBranchVisitorsHandler = (data) => {
  return {
    type: actionTypes.SOCKET_FETCH_ALL_BRANCH_VISITORS,
    value: data
  }
};
export const socketAddNewBranchVisitorHandler = (data) => {
  return {
    type: actionTypes.SOCKET_ADD_NEW_BRANCH_VISITOR,
    value: data
  }
};
export const socketDeleteIdListHandler = (data) => {
  return {
    type: actionTypes.SOCKET_DELETE_VISITORS_ID_LIST,
    value: data
  }
};
